export const LOAD_COMPANY_PROJECTS = "LOAD_COMPANY_PROJECTS";
export const LOAD_COMPANY_INFO = "LOAD_COMPANY_INFO";
export const LOGOUT = "LOGOUT";
export const CLEAR_LOAD_COMPANY_PROJECTS = 'CLEAR_LOAD_COMPANY_PROJECTS';
export const GET_COMPANY_ID_USER = 'GET_COMPANY_ID_USER';
